<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="用户">
                <GridSelectU
                    style="width: 177px;"
                    title="选择用户"
                    labelName="userName"
                    labelValue="id"
                    :value="queryForm.userId"
                    :limit="1"
                    size="small"
                    placeholder="请选择用户"
                    @getValue="getSearchValueUser"
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl="/mpp/user/findList"
                    entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get"
                >
                </GridSelectU>
            </el-form-item>
            <el-form-item label="店铺">
                <GridSelectShop
                    style="width: 177px"
                    title="选择店铺"
                    labelName="shopName"
                    labelValue="id"
                    :value="queryForm.shopId"
                    :limit="1"
                    size="small"
                    placeholder="请选择店铺"
                    @getValue="getSearchValueShopId"
                    :columns="SHOP_code"
                    :searchs="SHOP_search"
                    dataListUrl="/mall/shop/findList"
                    entityBeanName="mallShop"
                    queryEntityUrl="/mall/shop/get"
                >
                </GridSelectShop>
            </el-form-item>
            <el-form-item label="门店">
                <GridSelectLi
                    style="width: 177px"
                    title="选择门店"
                    labelName="storeName"
                    labelValue="id"
                    :value="queryForm.storeId"
                    :limit="1"
                    size="small"
                    placeholder="请选择门店"
                    @getValue="getSearchValueStoreId"
                    :columns="STORE_code"
                    :searchs="STORE_search"
                    dataListUrl="/shop/store/findList"
                    entityBeanName="shopStore"
                    queryEntityUrl="/shop/store/get"
                >
                </GridSelectLi>
            </el-form-item>
            <el-form-item label="数量类型">
                <el-select placeholder="请选择数量类型" clearable v-model="queryForm.amountTypes" style="width: 177px">
                    <el-option v-for="item in amountTypesList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMppUserGrowthRecordList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addMppUserGrowthRecord"
                    >新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editMppUserGrowthRecord(null)"
                    >修改</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMppUserGrowthRecord(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span title="导出数据" class="icon-box" @click="exportMppUserGrowthRecordList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshMppUserGrowthRecordList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="mppUserGrowthRecordList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="growthId"-->
<!--                    label="成长"-->
<!--                    width="180"-->
<!--                > </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="用户"
                    width="200"
                    prop="userId"
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="店铺"
                    width="180"
                    prop="shopId"
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="门店"
                    width="180"
                    prop="storeId"
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="amount"
                    label="数量"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="数量类型"
                    width="180"
                >
                    <template slot-scope="scope">
                        {{ getAmountTypes(scope.row.amountTypes) }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="parentPath"
                    label="父路径"
                    width="200"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="200"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkMppUserGrowthRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMppUserGrowthRecord(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteMppUserGrowthRecord(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="mppUserGrowthRecordStates[mppUserGrowthRecordState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
                :append-to-body="true"
            >
                <div>
                    <el-form
                        :model="mppUserGrowthRecord"
                        ref="mppUserGrowthRecordForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
<!--                        <el-form-item-->
<!--                            label="成长"-->
<!--                            prop="growthId"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 177px"-->
<!--                                v-model="mppUserGrowthRecord.growthId"-->
<!--                                :disabled="mppUserGrowthRecordState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="用户"
                            prop="userId"
                        >
                            <GridSelectU
                                style="width: 177px;"
                                title="选择用户"
                                labelName="userName"
                                labelValue="id"
                                :value="mppUserGrowthRecord.userId"
                                :limit="1"
                                size="small"
                                placeholder="请选择用户"
                                :disabled="mppUserGrowthRecordState == 'check'"
                                @getValue="getValueUser"
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl="/mpp/user/findList"
                                entityBeanName="mppUser"
                                queryEntityUrl="/mpp/user/get"
                            >
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="店铺"
                            prop="shopId"
                        >
                            <GridSelectShop
                                style="width: 177px"
                                title="选择店铺"
                                labelName="shopName"
                                labelValue="id"
                                :value="mppUserGrowthRecord.shopId"
                                :limit="1"
                                size="small"
                                placeholder="请选择店铺"
                                :disabled="mppUserGrowthRecordState == 'check'"
                                @getValue="getValueShopId"
                                :columns="SHOP_code"
                                :searchs="SHOP_search"
                                dataListUrl="/mall/shop/findList"
                                entityBeanName="mallShop"
                                queryEntityUrl="/mall/shop/get"
                            >
                            </GridSelectShop>
                        </el-form-item>
                        <el-form-item
                            label="门店"
                            prop="storeId"
                        >
                            <GridSelectLi
                                style="width: 177px"
                                title="选择门店"
                                labelName="storeName"
                                labelValue="id"
                                :value="mppUserGrowthRecord.storeId"
                                :limit="1"
                                size="small"
                                placeholder="请选择门店"
                                :disabled="mppUserGrowthRecordState == 'check'"
                                @getValue="getValueStoreId"
                                :columns="STORE_code"
                                :searchs="STORE_search"
                                dataListUrl="/shop/store/findList"
                                entityBeanName="shopStore"
                                queryEntityUrl="/shop/store/get"
                            >
                            </GridSelectLi>
                        </el-form-item>
                        <el-form-item
                            label="数量"
                            prop="amount"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="mppUserGrowthRecord.amount"
                                :disabled="mppUserGrowthRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="数量类型"
                            prop="amountTypes"
                        >
                            <el-select
                                placeholder="请选择数量类型"
                                clearable
                                multiple
                                :disabled="mppUserGrowthRecordState == 'check'"
                                v-model="mppUserGrowthRecord.amountTypes"
                                style="width: 177px"
                            >
                                <el-option
                                    v-for="item in amountTypesList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="父路径"
                            prop="parentPath"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="mppUserGrowthRecord.parentPath"
                                :disabled="mppUserGrowthRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="mppUserGrowthRecordState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import GridSelectShop from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { USER, USER_SEARCH, SHOP, SHOP_SEARCH, STORE, STORE_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU,
        GridSelectShop,
        GridSelectLi
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppUserGrowthRecordList();
                this.getMppUserGrowthRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppUserGrowthRecordList();
                this.getMppUserGrowthRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            STORE_code: STORE,
            STORE_search: STORE_SEARCH,
            queryForm: {
                growthId: '', //成长
                userId: '', //用户
                shopId: '', //店铺
                storeId: '', //门店
                amount: '', //数量
                amountTypes: '', //数量类型
                parentPath: '' //父路径
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppUserGrowthRecordState: 'add',
            mppUserGrowthRecordStates: {
                add: '新建用户成长记录',
                check: '查看用户成长记录',
                edit: '修改用户成长记录'
            },

            multipleSelection: [],
            mppUserGrowthRecordList: [],
            mppUserGrowthRecord: {
                id: '', //ID
                growthId: '', //成长
                userId: '', //用户
                shopId: '', //店铺
                storeId: '', //门店
                amount: '', //数量
                amountTypes: '', //数量类型
                parentPath: '' //父路径
            },
            btnLoading: false,

            rules: {
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                amount: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
                amountTypes: [{ required: true, message: '数量类型不能为空', trigger: 'blur' }]
            },

            amountTypesList: []
        };
    },
    created() {
        // 不在 created 中自动加载，等待 init 方法调用
        this.getAmountTypesList();
    },
    methods: {
        init(growthId) {
            this.resetMppUserGrowthRecordList();
            if (growthId) {
                this.queryForm.growthId = growthId;
                this.mppUserGrowthRecord.growthId = growthId;
            }
            this.getMppUserGrowthRecordList();
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        getValueUser(value) {
            this.mppUserGrowthRecord.userId = value;
        },
        getSearchValueUser(value) {
            this.queryForm.userId = value;
        },
        getValueShopId(value) {
            this.mppUserGrowthRecord.shopId = value;
        },
        getSearchValueShopId(value) {
            this.queryForm.shopId = value;
        },
        getValueStoreId(value) {
            this.mppUserGrowthRecord.storeId = value;
        },
        getSearchValueStoreId(value) {
            this.queryForm.storeId = value;
        },
        getAmountTypes(type) {
            if (!type) {
                return '--';
            }
            // 如果是逗号分隔的字符串，处理多个值
            if (typeof type === 'string' && type.includes(',')) {
                const types = type.split(',').map(t => t.trim());
                const result = [];
                for (const typeValue of types) {
                    for (const index in this.amountTypesList) {
                        if (this.amountTypesList[index].key == typeValue) {
                            result.push(this.amountTypesList[index].value);
                            break;
                        }
                    }
                }
                return result.length > 0 ? result.join(', ') : '--';
            }
            // 单个值的情况
            for (const index in this.amountTypesList) {
                if (this.amountTypesList[index].key == type) {
                    return this.amountTypesList[index].value;
                }
            }
            return '--';
        },
        //获取数量类型枚举
        getAmountTypesList() {
            get(`/mpp/utils/getEnum`, { enumType: `growth_search_type` }).then((res) => {
                if (res.success) {
                    this.amountTypesList = res.enumList;
                }
            });
        },
        resetMppUserGrowthRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppUserGrowthRecordList = [];
        },
        resetDialog() {
            this.mppUserGrowthRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                growthId: this.queryForm.growthId, //成长
                userId: '', //用户
                shopId: '', //店铺
                storeId: '', //门店
                amount: '', //数量
                amountTypes: '', //数量类型
                parentPath: '' //父路径
            };
            this.getMppUserGrowthRecordList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppUserGrowthRecord = {
                id: '', //ID
                growthId: this.mppUserGrowthRecord.growthId, //成长
                userId: '', //用户
                shopId: '', //店铺
                storeId: '', //门店
                amount: '', //数量
                amountTypes: '', //数量类型
                parentPath: '' //父路径
            };
        },
        submitForm() {
            if (this.mppUserGrowthRecordState == 'add') {
                this.$refs.mppUserGrowthRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        if(this.mppUserGrowthRecord.amountTypes && this.mppUserGrowthRecord.amountTypes.length != 0){
                            this.mppUserGrowthRecord.amountTypes = this.mppUserGrowthRecord.amountTypes.join(",")
                        }
                        post(`/mpp/usergrowthrecord/add`, { ...this.mppUserGrowthRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserGrowthRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.mppUserGrowthRecordState == 'edit') {
                this.$refs.mppUserGrowthRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.mppUserGrowthRecord.user;
                        delete this.mppUserGrowthRecord.shop;
                        delete this.mppUserGrowthRecord.store;
                        if(this.mppUserGrowthRecord.amountTypes && this.mppUserGrowthRecord.amountTypes.length != 0){
                            this.mppUserGrowthRecord.amountTypes = this.mppUserGrowthRecord.amountTypes.join(",")
                        }
                        post(`/mpp/usergrowthrecord/edit`, { ...this.mppUserGrowthRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserGrowthRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMppUserGrowthRecord() {
            this.showDialog = true;
            this.mppUserGrowthRecordState = 'add';
        },
        checkMppUserGrowthRecord(mppUserGrowthRecordId) {
            console.log(mppUserGrowthRecordId);
            this.currentMppUserGrowthRecordId = mppUserGrowthRecordId;

            this.getMppUserGrowthRecordById();
            this.showDialog = true;
            this.mppUserGrowthRecordState = 'check';
        },
        editMppUserGrowthRecord(mppUserGrowthRecordId) {
            console.log('mppUserGrowthRecord', mppUserGrowthRecordId);
            if (mppUserGrowthRecordId) {
                this.currentMppUserGrowthRecordId = mppUserGrowthRecordId;
                this.getMppUserGrowthRecordById();
            } else {
                this.mppUserGrowthRecord = { ...this.mppUserGrowthRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppUserGrowthRecordState = 'edit';
        },
        deleteMppUserGrowthRecord(mppUserGrowthRecordId) {
            let ids = '';
            if (mppUserGrowthRecordId) {
                ids = mppUserGrowthRecordId;
            } else {
                ids = this.multipleSelection.map((mppUserGrowthRecord) => mppUserGrowthRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/usergrowthrecord/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppUserGrowthRecordList();
                            this.getMppUserGrowthRecordList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshMppUserGrowthRecordList() {
            this.resetMppUserGrowthRecordList();
            this.getMppUserGrowthRecordList();
        },
        getMppUserGrowthRecordList(query = {}) {
            this.loading = true;
            get(`/mpp/usergrowthrecord/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppUserGrowthRecordList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMppUserGrowthRecordById() {
            get(`/mpp/usergrowthrecord/get`, { id: this.currentMppUserGrowthRecordId }).then((res) => {
                if (res.success) {
                    if(res.mppUserGrowthRecord.amountTypes && res.mppUserGrowthRecord.amountTypes.length != 0){
                        res.mppUserGrowthRecord.amountTypes = res.mppUserGrowthRecord.amountTypes.split(",").map(Number);
                    }
                    this.mppUserGrowthRecord = { ...this.mppUserGrowthRecord, ...res.mppUserGrowthRecord };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppUserGrowthRecordList() {
            exprotExcel(`/mpp/usergrowthrecord/export`, { ...this.queryForm });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppUserGrowthRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppUserGrowthRecordList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>

